import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceManagementService } from 'src/app/feature-modules/device-management/service/device-management.service';
import { DialogService } from '../../common-services/dialog.service';

@Component({
  selector: 'app-dialog-popover',
  templateUrl: './dialog-popover.component.html',
  styleUrls: ['./dialog-popover.component.scss']
})
export class DialogPopoverComponent {

  formGroup!: FormGroup;
  minNoOfDevices: number = 1;
  maxNoOfDevices: number = 100;

  constructor(
    private _fb: FormBuilder,
    private _dialogService: DialogService,
    private _deviceManagementService: DeviceManagementService,
    public dialogRef: MatDialogRef<DialogPopoverComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.formGroup = this._fb.group({
      noOfDevices: ['', [Validators.required, Validators.min(this.minNoOfDevices), Validators.max(this.maxNoOfDevices)]]
    });
    dialogRef.disableClose = true;
  }

  /**
   * Gets no of devices
   */
  get noOfDevices(): AbstractControl {
    return this.formGroup.get('noOfDevices') as AbstractControl;
  }


  /**
   * Validate device count as number
   * @param event
   * @param type
   */
  numberOnly(event: any, type?: string): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (type === 'countryCode' && charCode === 45) {
      return true;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  /**
   * Saves dialog popover component
   */
  save() {
    let dialogMsg: string = '';
    if (this.data?.type === 'Add Devices') {
      this._deviceManagementService.createNDevices(this.noOfDevices.value).subscribe({
        next: (result: any) => {
          const length = result?.data?.length;
          this.dialogRef.close();
          if (length == 0) {
            this._dialogService.showDialog('Info', 'Unable to create a devices');
            return;
          }
          if (length === 1) {
            dialogMsg = 'Device ' + result?.data[0].deviceName;
          }
          else if (length <= 2) {
            dialogMsg = 'Devices ' + result?.data[0].deviceName + ' , ' + result?.data[length - 1].deviceName;
          } else {
            dialogMsg = 'Devices ' + result?.data[0].deviceName + ' - ' + result?.data[length - 1].deviceName;
          }
          this._dialogService.showDialog('Success ', dialogMsg + ' created successfully');
        },
        error: () => {
          this.dialogRef.close();
          this._dialogService.showDialog('Error', 'Unable to create a devices');
        }
      });
    }
    this.dialogRef.close(true);
  }
}
